// src/baseurl.js

// Change this to your backend URL
// export const baseurl = "http://192.168.10.227:5000/api/";
// export const baseurl = "http://localhost:5000/api/";
export const baseurl = "https://backend.soulsathi.com/api/";

// Optional: if you have an image storage URL
// export const imgurl = "http://192.168.10.227:5000/";
export const imgurl = "https://backend.soulsathi.com/";